export const Loading = () => {
	return (
		<div className="flex h-full w-full justify-center py-16">
			{/* loading spinner */}
			Loading...
		</div>
	);
};
